import GPNDao from "../gpn-snapshot/gpn-snapshot.dao";
import OPNDao, { OPNDaoConfig } from "../opn-snapshot/opn-snapshot.dao";
import { GpnStockForecast, Inventory, OPNParameters, Price } from "../opn-snapshot/opn-snapshot.interface";
import { OPNDetail } from "./opn-details.interface";

export default class OPNDetailsDao {

    public static async getOPNDetails(opn: string, gpn: string, locale: string, config?: OPNDaoConfig): Promise<OPNDetail> {
        config = config || new OPNDaoConfig();
        const match: OPNDetail = await OPNDetailsDao.fetchOPNDetails(opn, gpn, locale, config);
        return match;
    }

    public static async fetchOPNDetails(opn: string, gpn: string, locale: string, config?: OPNDaoConfig): Promise<OPNDetail> {
        opn = opn.trim().toUpperCase();
        config = config || new OPNDaoConfig();
        const opnParameters: OPNParameters = await OPNDao.fetchOPNParameters(opn, gpn, locale, config);
        // opn inventory
        const gpnInventory: Map<String, Inventory> = await GPNDao.fetchGPNInventory(gpn);
        OPNDao.setOPNInventory(gpnInventory, opnParameters);
        // opn forecast
        const gpnInventoryForecast: GpnStockForecast = await GPNDao.fetchGPNInventoryForecast(gpn, locale);
        const opnInventoryForecast = OPNDao.getOPNInventoryForecast(gpnInventoryForecast, opn);
        opnParameters.inventoryForecast = opnInventoryForecast && opnInventoryForecast.forecast ? opnInventoryForecast.forecast : null;
        const currencyExchangeRateMap: { [currency: string]: number } = await GPNDao.fetchCurrencyExchangeRate(gpn, locale);
        const customReelFees: Price[] = await OPNDao.fetchCustomReelFees(config);
        const opnDetails: OPNDetail = {
            opn: opn,
            gpn: gpn,
            opnParameters: opnParameters,
            currencyExchangeRateMap: currencyExchangeRateMap,
            customReelPriceList: JSON.stringify(customReelFees.map(currencyData => {
                return {
                    "currency": currencyData.currency,
                    "currency_price": currencyData.currencyPrice ? currencyData.currencyPrice.toString() : ''
                }
            }))
        };
        return opnDetails;
    }

}
